<html>

<body>

    <div class="divider">
        <div class="left-side">
        </div>

        <div class="right-side">
          <div class="row logo  d-flex justify-content-center">
              <img src="assets/images/logo.jpg" width="150px" height="80px">
          </div>
          <div class="row company-title d-flex justify-content-center text-right text-muted">
            Welcome to Maritime Logistic Platform
          </div>

          <br><br><br>

          <div class="row">
            <div class="col-md-12 d-flex justify-content-center">
              <form [formGroup] ="loginForm" (ngSubmit)="onSubmit()" autocomplete="off">
                <mat-form-field class="controles-container" appearance="outline">
                  <mat-label>Username</mat-label>
                  <input  placeholder="Your Username"   formControlName="username" (blur)="logValidationErrors()" matInput>   
                  <mat-icon matSuffix>person</mat-icon>              
                  <mat-error *ngIf="formErrors.username">{{formErrors.username}}</mat-error>
                </mat-form-field> 
  
                <mat-form-field class="controles-container mt-2" appearance="outline">
                  <mat-label>Password</mat-label>
                  <input [type]="hidePassword ? 'password' : 'text'"  placeholder="Your Password"   formControlName="password" (blur)="logValidationErrors()" matInput>   
                  <a  (click)="hidePassword = !hidePassword" href="#" matSuffix onClick="return false;">
                  <mat-icon style="color: black;">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                   </a>
                  <mat-error *ngIf="formErrors.password">{{formErrors.password}}</mat-error>
                </mat-form-field> 
                <div class="row">
                <span class="text-danger ml-4" *ngIf="isInvalidData && !formErrors.password">{{invalidMessage}}</span>
               </div>
                
                <div class="d-flex mb-5 align-items-center">
                  <mat-checkbox class="ml-2" formControlName="rememberMe">Keep me logged in</mat-checkbox>
                  <a routerLink="/reset-password-request"  class="forgot-pass ml-auto text-primary">Forgot Password</a>
                </div>
  
                <button [disabled]="!loginForm.valid" 
                [ngClass]="{'loginBtnActive' : loginForm.valid,'loginBtnDisabled' : !loginForm.valid }"
                 type="submit" class="btn btn-lg btn-block btn-primary">
               <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                LOG IN
               </button>
  
              </form>
            </div>
          </div>

      </div>
    </div>


    
     <!-- Form Values : {{ loginForm.value | json }}   -->

  </body>
  </html>
